<template>
  <header>
    <div class="close-slide-up-container">
      <button class="link" @click="$emit('close-share')">
        <ns-icon icon-name="icon-close" class="close-slide-up" />
      </button>
      <button v-if="!showFaq" class="link back-link" @click="$emit('open-manager')">
        <ns-icon icon-name="icon-narrow-angle-left-24" /> {{ back }}
      </button>
    </div>
    <h2 v-if="!showFaq">{{ title }}</h2>
    <h2 v-if="showFaq">{{ faqTitle }}</h2>
    <p  v-if="!showFaq" class="paragraph-m" v-html="subtitle"></p>
    <div v-if="showPartialReturn" class="partialReturnHeaderTitleButtonRow">
      <button
        class="returnSelectedButton"
        :class="{
            returnButtonEnabled: returnAmount > 0,
            returnButtonDisabled: returnAmount === 0,
          }"
        :disabled="returnAmount === 0"
        @click="$emit('open-modal', { type: 'selected'})"
      >
        {{ tdc.tdc_returnSelectedAllocationsText + ( returnAmount > 0 ? (' ( ' + returnAmount + ' )') : '' ) }}
      </button>
      <button
        class="returnAllButton"
        @click="$emit('open-modal', { type: 'all' })"
      >
        {{tdc.tdc_returnAllAllocationsText}}
      </button>
    </div>
  </header>
</template>

<script>
import config from '../js/qualificationsConfigService'
import {
  StringService,
} from '@nuskin/ns-util'
import { NsIcon } from '@nuskin/ns-icon'

export default {
  components: {
    NsIcon,
  },
  data() {
    return {
      back: 'Prev',
      tdc: config.getTdc(),
    }
  },
  methods: {
    setCommonStrings() {
      const commonStrings = [{ key: 'back', dflt: 'Back' }]
      StringService.getStrings(commonStrings).then((strings) => {
        this.back = strings.back
      })
    },
  },
  mounted() {
    this.setCommonStrings()
  },
  name: 'AllocationHeader',
  props: {
    returnAmount: {
      type: Number,
      default: 0,
    },
    qualifications: Array,
    selectedReturns: Object,
    subtitle: String,
    faqTitle: String,
    showPartialReturn: Boolean,
    title: String,
    showFaq: Boolean,
  },
}
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

$blackhole: map.get(colors.$baseColors, "blackhole");
$shells: map.get(colors.$baseColors, "shells");
header {
  .close-slide-up-container {
    margin-bottom: 15px;
  }

  .slide-up .slide-up-content .close-slide-up-container {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;

    .back-link {
      color: $shells;
    }
  }

  div.partialReturnHeaderTitleButtonRow {
    display: flex;
    margin-top: 15px;

    button {
      border-radius: 3px;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      height: 45px;
      width: 330px;
      display: flex;
      justify-content: center;
    }

    .returnAllButton:hover {
      background-color: #f4f4f4;
      border-color: $blackhole;
    }

    .returnAllButton {
      background: white;
      border: 1px solid $blackhole;
      color: $blackhole;
    }

    .returnButtonEnabled {
      background-color: $blackhole;
      color: white;
    }

    .returnButtonEnabled:hover {
      background-color: #5a5a57;
      border-color: #5a5a57;
    }

    .returnButtonDisabled {
      background: #BBBCBC;
      margin-right: 15px;
      color: darkgrey;
    }
    .returnSelectedButton {
      margin-right: 15px;
    }
  }
}

@media (max-width: 375px) {
  header {
    .partialReturnHeaderTitleButtonRow {
      flex-direction: column;
      .returnSelectedButton {
        margin-right: 0;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
